<template>
  <div class="parcs-component">
    <ul class="parcs" v-if="content">
      <li :style="setBackground(item.img)" :key="i" v-for="(item, i) in content.items">
        <router-link :to="item.link.cached_url">
          <h2 v-html="item.title"></h2>
        </router-link>
      </li>
    </ul>
    <ul class="parcs-text">
      <li :style="setColor(item.color)" :key="i" v-for="(item, i) in content.items">
        <router-link :to="item.link.cached_url">
          <h3 v-html="item.title"></h3>
          <p v-html="item.text"></p>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import backgroundFollow from "@/mixins/backgroundFollow.js";
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [backgroundFollow, storyblokLink],
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  methods: {
    setColor(color) {
      return {
        backgroundColor: color.color
      };
    }
  }
};
</script>

<style lang="scss">
.parcs {
  width: $content-width;
  max-width: $max-width;
  margin: auto;
  overflow: hidden;
  height: 700px;
  position: relative;
  overflow: hidden;
  > li {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100%;
    position: absolute;
    width: 100%;
    transform: scale(1);
    transition: clip-path 0.6s cubic-bezier(0.58, 0.18, 0.45, 0.95),
      transform 0.4s ease-in-out 0.2s;
    > a {
      display: block;
      text-decoration: none;
      color: #fff;
      position: relative;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      h2 {
        width: 75%;
        text-align: left;
        margin: auto;
        font-size: 35px;
      }
    }
    &:nth-child(2) {
      > a {
        h2 {
          text-align: right;
        }
      }
    }
  }
}

.parcs > li:hover {
  transform: scale(1.1);
}
.parcs > li:nth-child(2) {
  clip-path: polygon(70% 0, 100% 0, 100% 100%, 30% 100%);
  z-index: 1;
  &:hover {
    clip-path: polygon(45% 0, 100% 0%, 100% 100%, 5% 100%);
  }
}
.parcs > li:nth-child(1):hover + li {
  clip-path: polygon(95% 0, 100% 0, 100% 100%, 55% 100%);
}
.parcs-text {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;
  width: $content-width;
  margin: 1em auto;
  max-width: $max-width;
  > li {
    padding: 20px;
    border-radius: 3px;
    transition: box-shadow 0.2s ease-in-out;
    height: 400px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 22px;
      margin-right: 10px;
    }

    &::-webkit-scrollbar-track {
      margin: 10px 0;
      box-shadow: inset 0 0 10px 10px rgba(0, 0, 0, 0.3);
      border: solid 8px transparent;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 10px 10px #fff;
      border: solid 8px transparent;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #fff;
    }
    &:nth-child(1) {
      &:hover {
        box-shadow: 0px 0px 0px 10px $stefoy-D;
      }
    }
    &:nth-child(2) {
      &:hover {
        box-shadow: 0px 0px 0px 10px $alb-D;
      }
    }
    h3 {
      color: #fff;
      padding-bottom: 0.5em;
    }
    a {
      text-decoration: none;
      line-height: 1.2;
    }
    p {
      color: #fff;
      white-space: pre-line;
    }
  }
}
@media screen and (max-width: $tablet) {
  .parcs-text {
    display: flex;
    flex-direction: column;
    > li {
      margin: 1em 1.5em;
    }
  }
  .parcs {
    height: 445px;

    li:nth-child(1) {
      a {
        h2 {
          position: absolute;
          top: 10%;
          left: 5%;
          font-size: 28px;
        }
      }
    }
    li:nth-child(2) {
      a {
        h2 {
          position: absolute;
          bottom: 10%;
          right: 5%;
          font-size: 28px;
        }
      }
    }
  }
}
</style>
